import { filemanagerUrls } from '@/api/urls/filemanager';

import { ATTACHMENT_TYPE, FILE_ATTACH_TYPE } from '@/constants/filemanager';

import { GenerateFilePreviewUrlInputType, GenerateFilePreviewUrlResultType } from './models';

export const GenerateFilePreviewUrl = ({
    attachableId,
    type,
    attachment,
    width,
    height,
    thumbnail,
    placeHolder,
    isPrimary,
    sortOrder
}: GenerateFilePreviewUrlInputType): GenerateFilePreviewUrlResultType => {
    const baseUrl = filemanagerUrls.previewFile;
    const url = new URL(baseUrl);

    url.searchParams.append('attachableId', attachableId);
    url.searchParams.append('type', String(FILE_ATTACH_TYPE[type].value));
    url.searchParams.append('attachment', String(ATTACHMENT_TYPE[attachment].value));
    url.searchParams.append('isPrimary', String(isPrimary));
    url.searchParams.append('sortOrder', String(sortOrder));

    if (width) {
        url.searchParams.append('width', String(width));
    }

    if (height) {
        url.searchParams.append('height', String(height));
    }

    if (thumbnail !== undefined) {
        url.searchParams.append('thumbnail', String(thumbnail));
    }

    if (placeHolder !== undefined) {
        url.searchParams.append('placeHolder', String(placeHolder));
    }

    return { src: url.toString() };
};
